import { actions } from './action'

const initialState = {
  traineeData: {
    traineeList: [],
    totalCount: 0,
  },
  pagination: {
    skip: 0,
    limit: 10,
  },
}
const traineeState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_TRAINEES:
      return {
        ...state,
        traineeData: {
          traineeList: action.payload.traineeList,
          totalCount: action.payload.totalCount,
        },
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    default:
      return state
  }
}
export default traineeState
